import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// sales_orders — ใบสั่งขาย (Sales Order)
// ============================================================================
export const salesOrders = sqliteTable("sales_orders", {
  id: text("id").primaryKey(), // ULID
  orderNo: text("order_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  partyType: text("party_type", {
    enum: ["customer"],
  }).notNull().default("customer"),
  partyId: text("party_id").notNull(),
  orderDate: text("order_date").notNull(),
  expiryDate: text("expiry_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  total: real("total").notNull().default(0),
  status: text("status", {
    enum: [
      "draft",
      "submitted",
      "approved",
      "partially_delivered",
      "delivered",
      "partially_billed",
      "invoiced",
      "cancelled",
    ],
  })
    .notNull()
    .default("draft"),
  sourceQuotationId: text("source_quotation_id"),
  convertedToInvoiceId: text("converted_to_invoice_id"),
  remarks: text("remarks"),
  customData: text("custom_data"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  companyStatusIdx: index("so_company_status_idx").on(table.companyId, table.status, table.orderDate),
  companyPartyIdx: index("so_company_party_idx").on(table.companyId, table.partyId),
  sourceQuotationIdx: index("so_source_quotation_idx").on(table.sourceQuotationId),
  convertedIdx: index("so_converted_idx").on(table.convertedToInvoiceId),
}));

// Type exports
export type SalesOrder = typeof salesOrders.$inferSelect;
export type NewSalesOrder = typeof salesOrders.$inferInsert;
